import { useFetchBusinessUnits } from 'asset-actions-lib-forms/manageAccess/useFetchBusinessUnits';
import BusinessUnitSelect from 'ui-business-units-lib/components/BusinessUnitSelect';
import { jsx as _jsx } from "react/jsx-runtime";
export default function BusinessUnitSelector({
  onChange,
  value
}) {
  const {
    loading,
    data: buOptions
  } = useFetchBusinessUnits();
  return /*#__PURE__*/_jsx(BusinessUnitSelect, {
    buId: value,
    buOptions: buOptions,
    isLoading: loading,
    onChange: onChange
  });
}